module.exports = __webpack_public_path__ + "img/z-2.175203f0.png";